(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-circle"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sectionId = '{{ section.id }}';
  const circle = document.getElementById("rotatingCircle-" + sectionId);
  if (!circle) return;
  
  const images = circle.querySelectorAll("img");

  function positionImages() {
    const size = circle.offsetWidth;
    if (size === 0) return;
    
    const radius = size / 2 - 40;
    const center = size / 2;
    const total = images.length;

    images.forEach((img, index) => {
      const angle = (index / total) * (2 * Math.PI);
      const x = center + radius * Math.cos(angle) - img.offsetWidth / 2;
      const y = center + radius * Math.sin(angle) - img.offsetHeight / 2;

      img.style.position = 'absolute';
      img.style.left = `${x}px`;
      img.style.top = `${y}px`;

      const angleDeg = angle * (180 / Math.PI) + 90;
      img.style.transform = `rotate(${angleDeg}deg)`;
    });
  }

  if (images.length > 0) {
    positionImages();
    window.addEventListener("resize", positionImages);
    
    // Re-position after images load
    images.forEach(img => {
      img.addEventListener('load', positionImages);
    });
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initReviewSlider(container) {
    if (!container) return;
    
    const sectionId = container.dataset.sectionId;
    const track = container.querySelector('[data-slider-track]');
    if (!track) return;
    
    const slides = track.querySelectorAll(".review_slider_items_card");
    const nextBtn = container.querySelector('#review_next-' + sectionId) || container.querySelector('.arrow-button--next');
    const prevBtn = container.querySelector('#review_pre_back-' + sectionId) || container.querySelector('.arrow-button--prev');

    if (slides.length === 0) return;

    let index = 0;
    const total = slides.length;

    slides.forEach(slide => {
      slide.style.flex = "0 0 100%";
    });

    function moveSlider() {
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    // Initialize position
    moveSlider();

    // Add click listeners to buttons
    if (nextBtn) {
      // Remove any existing listeners
      const newNextBtn = nextBtn.cloneNode(true);
      nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
      
      newNextBtn.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        index = (index + 1) % total;
        moveSlider();
      });
      
      // Ensure button is visible
      newNextBtn.style.display = 'flex';
      newNextBtn.style.visibility = 'visible';
      newNextBtn.style.opacity = '1';
    }

    if (prevBtn) {
      // Remove any existing listeners
      const newPrevBtn = prevBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
      
      newPrevBtn.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        index = (index - 1 + total) % total;
        moveSlider();
      });
      
      // Ensure button is visible
      newPrevBtn.style.display = 'flex';
      newPrevBtn.style.visibility = 'visible';
      newPrevBtn.style.opacity = '1';
    }
  }

  function initAllSliders() {
    const containers = document.querySelectorAll('.reviews-slider-container[data-section-id]');
    containers.forEach(container => {
      initReviewSlider(container);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Re-initialize on Shopify section load
  document.addEventListener('shopify:section:load', (event) => {
    const container = document.querySelector(`.reviews-slider-container[data-section-id="${event.detail.sectionId}"]`);
    if (container) {
      setTimeout(() => initReviewSlider(container), 100);
    }
  });

  // Also listen for theme:section:load for compatibility
  document.addEventListener('shopify:section:reorder', initAllSliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-circle"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Find all rotating circle containers on the page
  const circles = document.querySelectorAll('.rotating-circle[data-section-id]');
  
  circles.forEach(function(circle) {
    const sectionId = circle.getAttribute('data-section-id');
    
    function initRotatingCircle() {
      // Re-query to ensure we have the latest element
      const currentCircle = document.querySelector('.rotating-circle[data-section-id="' + sectionId + '"]');
      if (!currentCircle) {
        setTimeout(initRotatingCircle, 50);
        return;
      }

      function duplicateImages() {
        // Get original images
        const originalImages = currentCircle.querySelectorAll('.circle-image-original');
        if (originalImages.length === 0) {
          setTimeout(duplicateImages, 50);
          return;
        }
        
        // Target number of images to fill the circle (12-18 works well)
        const targetCount = 18;
        const originalCount = originalImages.length;
        
        // Calculate how many times to duplicate each image
        const duplicatesPerImage = Math.ceil(targetCount / originalCount);
        
        // Clone and append images
        for (let i = 0; i < originalCount; i++) {
          const original = originalImages[i];
          // Keep the first original, clone the rest
          for (let j = 1; j < duplicatesPerImage; j++) {
            const clone = original.cloneNode(true);
            clone.classList.remove('circle-image-original');
            clone.classList.add('circle-image-clone');
            currentCircle.appendChild(clone);
          }
        }
      }
      
      function positionImages() {
        const images = currentCircle.querySelectorAll("img");
        if (images.length === 0) {
          setTimeout(positionImages, 50);
          return;
        }
        
        const size = currentCircle.offsetWidth;
        if (size === 0) {
          setTimeout(positionImages, 50);
          return;
        }
        
        const radius = size / 2 - 40;
        const center = size / 2;
        const total = images.length;

        // Convert to array and ensure each element is unique
        const imagesArray = Array.from(images);
        
        imagesArray.forEach((img, index) => {
        // Calculate unique angle for each image
        const angle = (index / total) * (2 * Math.PI);
        const angleDeg = angle * (180 / Math.PI);

        // Get dimensions for IMG
        const imgWidth = img.offsetWidth || img.naturalWidth || 113;
        const imgHeight = img.offsetHeight || img.naturalHeight || 109;

        // Calculate position
        const x = center + radius * Math.cos(angle) - imgWidth / 2;
        const y = center + radius * Math.sin(angle) - imgHeight / 2;

        // Apply styles directly (inline styles have higher specificity)
        img.style.position = 'absolute';
        img.style.left = `${x}px`;
        img.style.top = `${y}px`;
        img.style.margin = '0';
        img.style.marginLeft = '0';
        img.style.marginTop = '0';
        img.style.marginRight = '0';
        img.style.marginBottom = '0';

        // Rotate to face outward
        const rotationDeg = angleDeg + 90;
        img.style.transform = `rotate(${rotationDeg}deg)`;
        img.style.transformOrigin = 'center center';
        img.style.zIndex = '1';
        
        });
      }

      // First duplicate images, then position them
      duplicateImages();
      
      // Wait a bit for images to be duplicated, then position
      setTimeout(function() {
        positionImages();
        window.addEventListener("resize", positionImages);
        
        // Re-position after images load
        const images = currentCircle.querySelectorAll("img");
        images.forEach(img => {
          if (!img.complete) {
            img.addEventListener('load', positionImages, { once: true });
          }
        });
        
        // Additional positioning attempts
        setTimeout(positionImages, 100);
        setTimeout(positionImages, 300);
      }, 50);
    }
    
    // Initialize this circle
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRotatingCircle);
    } else {
      initRotatingCircle();
    }
    
    // Also try after a delay as fallback
    setTimeout(initRotatingCircle, 500);
    
    // Re-initialize on section load (for theme editor)
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === sectionId) {
        setTimeout(initRotatingCircle, 100);
      }
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-studio-track]').forEach(function (track) {
      var galleryId = track.dataset.studioTrack;
      var gallery = track.closest('[data-studio-gallery]');
      var dots = document.querySelectorAll(
        '[data-studio-dot][data-studio-gallery="' + galleryId + '"]'
      );
      var slideCount = track.querySelectorAll('.studio-showcase-mobile-slide').length;
      var currentIndex = 0;

      function goTo(index) {
        index = Math.max(0, Math.min(index, slideCount - 1));
        currentIndex = index;
        var percent = slideCount > 0 ? (index * 100 / slideCount) : 0;
        track.style.transform = 'translateX(-' + percent + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === index);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(this.dataset.studioDot, 10));
        });
      });

      if (slideCount <= 1 || !gallery) return;

      var touchStartX = 0;
      var touchEndX = 0;
      gallery.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var threshold = 50;
        if (touchStartX - touchEndX > threshold) {
          goTo(currentIndex + 1);
        } else if (touchEndX - touchStartX > threshold) {
          goTo(currentIndex - 1);
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
